import { useState } from 'react';
import { AnimatedCheckScreen } from 'components/screens';
import { getEmployerPolicies } from 'helpers';
import history from 'helpers/history';
import QuestionPage from '../pages/QuestionPage';
import styles from '../styles/CoversForm.module.scss';
import { HOME_ROUTE } from 'constants/routes';

const CoversForm = (
  { employer, formTitle, formImage, questions, policies, user, submitEmployer },
  ref: any,
) => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (data) => {
    const updatedUser = {
      ...user,
      ...data,
    };

    if (!user.q4eOption || data.q4eOption !== user.q4eOption) {
      submitEmployer(updatedUser);
      setSubmitted(true);
    } else {
      const [policy] = getEmployerPolicies(policies, employer);
      if (policy) {
        history.push(HOME_ROUTE);
      }
    }
  };

  const getSubmitText = (data) => {
    if (!user.q4eOption) {
      return 'Add';
    } else if (data.q4eOption === user.q4eOption) {
      return 'View on dashboard';
    }
    return 'Update dashboard';
  };

  if (submitted) {
    return <AnimatedCheckScreen onFinish={() => setSubmitted(false)} />;
  }

  return (
    <div id="q4e-anchor" className={styles.container}>
      <QuestionPage
        buttonClassName={styles.formButtons}
        className={styles.form}
        title={formTitle}
        questions={questions}
        values={user}
        onSubmit={handleSubmit}
        getSubmitText={getSubmitText}
      />
      {formImage && (
        <div className={styles.imgContainer}>
          <img alt="Form image" src={formImage} />
        </div>
      )}
    </div>
  );
};

export default CoversForm;
